<template>
  <div class="employee-manage-container">
    <div class="page-header">
      <div class="header-left">
        <i class="el-icon-arrow-left" @click="goBack"></i>
        <span class="page-title">考勤统计</span>
      </div>
      <el-button type="primary" size="small" @click="handleExport">
        <i class="el-icon-download"></i> 导出报表
      </el-button>
    </div>

    <div class="search-bar">
      <el-date-picker
        v-model="searchForm.yearMonth"
        type="month"
        placeholder="统计月份"
        value-format="yyyy-MM"
        style="width: 150px"
        @change="handleSearch"
      />
      <el-select v-model="searchForm.departmentId" placeholder="全部部门" clearable style="width: 150px; margin-left: 10px;" @change="handleSearch">
        <el-option label="全部部门" value="" />
        <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id" />
      </el-select>
      <el-select v-model="searchForm.userRole" placeholder="全部角色" clearable style="width: 150px; margin-left: 10px;" @change="handleSearch">
        <el-option label="全部角色" value="" />
        <el-option label="内勤" value="STAFF" />
        <el-option label="教练" value="COACH" />
        <el-option label="司机" value="DRIVER" />
        <el-option label="业务员" value="SALES" />
        <el-option label="财务" value="FINANCE" />
        <el-option label="人事" value="HR" />
      </el-select>
      <el-input placeholder="姓名/工号" v-model="searchForm.keyword" style="width: 150px; margin-left: 10px;" clearable @keyup.enter.native="handleSearch">
        <i slot="prefix" class="el-icon-search"></i>
      </el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px;">
        <i class="el-icon-search"></i> 查询
      </el-button>
      <el-button @click="handleReset" style="margin-left: 10px;">
        <i class="el-icon-refresh"></i> 重置
      </el-button>
    </div>

    <!-- 统计概览卡片 -->
    <div class="stats-cards">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="stat-card normal">
            <div class="stat-icon"><i class="el-icon-circle-check"></i></div>
            <div class="stat-info">
              <div class="stat-value">{{ statsOverview.normal }}</div>
              <div class="stat-label">正常</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card warning">
            <div class="stat-icon"><i class="el-icon-warning"></i></div>
            <div class="stat-info">
              <div class="stat-value">{{ statsOverview.late }}</div>
              <div class="stat-label">迟到</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card warning">
            <div class="stat-icon"><i class="el-icon-bottom"></i></div>
            <div class="stat-info">
              <div class="stat-value">{{ statsOverview.early }}</div>
              <div class="stat-label">早退</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="stat-card danger">
            <div class="stat-icon"><i class="el-icon-close"></i></div>
            <div class="stat-info">
              <div class="stat-value">{{ statsOverview.absent }}</div>
              <div class="stat-label">缺卡</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 考勤明细表格 -->
    <el-card class="table-card">
      
      <el-table
        v-loading="loading"
        :data="tableData"
        stripe
        border
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column prop="userName" label="姓名" width="100" fixed />
        <el-table-column prop="department" label="部门" width="100" />
        <el-table-column prop="userRole" label="角色" width="80">
          <template slot-scope="scope">
            <el-tag size="small" :type="getRoleTagType(scope.row.userRole)">
              {{ getRoleName(scope.row.userRole) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="date" label="日期" width="110" sortable />
        <el-table-column prop="weekday" label="星期" width="70" />
        <el-table-column prop="morningTime" label="上班打卡" width="100">
          <template slot-scope="scope">
            <span :class="getTimeClass(scope.row.morningTime, 'morning')">
              {{ scope.row.morningTime || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="eveningTime" label="下班打卡" width="100">
          <template slot-scope="scope">
            <span :class="getTimeClass(scope.row.eveningTime, 'evening')">
              {{ scope.row.eveningTime || '-' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="workDuration" label="工作时长" width="90" />
        <el-table-column prop="status" label="状态" width="90">
          <template slot-scope="scope">
            <el-tag size="small" :type="getStatusTagType(scope.row.status)">
              {{ getStatusName(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="isRemote" label="异地打卡" width="90">
          <template slot-scope="scope">
            <span v-if="scope.row.isRemote" class="remote-badge">是</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="150" show-overflow-tooltip />
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="pagination.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagination.pageSize"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        />
      </div>
    </el-card>
  </div>
</template>

<script>
import * as checkinApi from '@/api/checkinApi.js'

export default {
  name: 'CheckinStats',
  data() {
    return {
      searchForm: {
        yearMonth: '',
        departmentId: '',
        userRole: '',
        keyword: ''
      },
      departmentList: [
        { id: '1', name: '行政部' },
        { id: '2', name: '市场部' },
        { id: '3', name: '培训部' },
        { id: '4', name: '后勤部' }
      ],
      statsOverview: {
        normal: 0,
        late: 0,
        early: 0,
        absent: 0
      },
      tableData: [],
      loading: false,
      pagination: {
        page: 1,
        pageSize: 20
      },
      total: 0
    }
  },
  created() {
    // 默认当月
    const now = new Date()
    this.searchForm.yearMonth = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`
    this.loadData()
  },
  methods: {
    goBack() {
      this.$router.push('/home/workbench')
    },
    async loadData() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          page: this.pagination.page,
          pageSize: this.pagination.pageSize
        }
        
        // 加载统计数据和明细列表
        const [statsResult, listResult] = await Promise.all([
          checkinApi.getCheckinStats({ yearMonth: this.searchForm.yearMonth }),
          checkinApi.getCheckinRecordList(params)
        ])
        
        if (statsResult) {
          this.statsOverview = {
            normal: statsResult.normalCount || 0,
            late: statsResult.lateCount || 0,
            early: statsResult.earlyCount || 0,
            absent: statsResult.absentCount || 0
          }
        }
        
        if (listResult) {
          this.tableData = listResult.list || []
          this.total = listResult.total || 0
        }
      } catch (e) {
        console.error('加载考勤数据失败', e)
        this.$message.error('加载数据失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadData()
    },
    handleReset() {
      const now = new Date()
      this.searchForm = {
        yearMonth: `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`,
        departmentId: '',
        userRole: '',
        keyword: ''
      }
      this.pagination.page = 1
      this.loadData()
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handlePageChange(val) {
      this.pagination.page = val
      this.loadData()
    },
    async handleExport() {
      try {
        const params = { ...this.searchForm }
        const blob = await checkinApi.exportCheckinRecord(params)
        
        const url = window.URL.createObjectURL(new Blob([blob]))
        const link = document.createElement('a')
        link.href = url
        link.download = `考勤报表_${this.searchForm.yearMonth}.xlsx`
        link.click()
        window.URL.revokeObjectURL(url)
        
        this.$message.success('导出成功')
      } catch (e) {
        this.$message.error('导出失败')
      }
    },
    getRoleTagType(role) {
      const map = {
        'STAFF': '',
        'COACH': 'success',
        'DRIVER': 'warning',
        'SALES': 'info',
        'FINANCE': 'danger',
        'HR': ''
      }
      return map[role] || ''
    },
    getRoleName(role) {
      const map = {
        'STAFF': '内勤',
        'COACH': '教练',
        'DRIVER': '司机',
        'SALES': '业务员',
        'FINANCE': '财务',
        'HR': '人事'
      }
      return map[role] || role
    },
    getStatusTagType(status) {
      const map = {
        'NORMAL': 'success',
        'LATE': 'warning',
        'EARLY': 'warning',
        'ABSENT': 'danger',
        'REMOTE': 'info'
      }
      return map[status] || ''
    },
    getStatusName(status) {
      const map = {
        'NORMAL': '正常',
        'LATE': '迟到',
        'EARLY': '早退',
        'ABSENT': '缺卡',
        'REMOTE': '异地'
      }
      return map[status] || status
    },
    getTimeClass(time, type) {
      if (!time) return ''
      const [hour, minute] = time.split(':').map(Number)
      
      if (type === 'morning') {
        return (hour > 8 || (hour === 8 && minute > 30)) ? 'time-late' : 'time-normal'
      } else {
        return hour < 18 ? 'time-early' : 'time-normal'
      }
    }
  }
}
</script>

<style scoped>
.employee-manage-container {
  height: 100%;
  background: #f5f7fa;
  overflow: auto;
  padding-bottom: 20px;
}

.page-header {
  background: #fff;
  padding: 16px 20px;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-left i {
  font-size: 18px;
  cursor: pointer;
  color: #606266;
}

.header-left i:hover {
  color: #409eff;
}

.page-title {
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}

.search-bar {
  display: flex;
  align-items: center;
  margin: 15px 20px;
  background: #fff;
  padding: 15px;
  border-radius: 4px;
}

.stats-cards {
  margin: 0 20px 20px;
  overflow: hidden;
}

.stat-card {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.stat-card .stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #fff;
  margin-right: 16px;
}

.stat-card.normal .stat-icon { background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%); }
.stat-card.warning .stat-icon { background: linear-gradient(135deg, #e6a23c 0%, #ebb563 100%); }
.stat-card.danger .stat-icon { background: linear-gradient(135deg, #f56c6c 0%, #f78989 100%); }

.stat-card .stat-info .stat-value {
  font-size: 32px;
  font-weight: bold;
  color: #303133;
}

.stat-card .stat-info .stat-label {
  font-size: 14px;
  color: #909399;
}

.table-card {
  margin: 0 20px;
  border-radius: 8px;
  background: #fff;
  padding: 15px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record-count {
  font-size: 12px;
  color: #909399;
  font-weight: normal;
}

.time-normal { color: #67c23a; }
.time-late { color: #e6a23c; }
.time-early { color: #e6a23c; }

.remote-badge {
  background: #fdf6ec;
  color: #e6a23c;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.pagination-container {
  margin-top: 20px;
  text-align: right;
}
</style>
